import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/design";
import { contentSpacingStyles } from "@store/theme/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export const pageTitleProps: TypographyPresentationProps = {
    variant: "h1",
    forwardAs: "h1",
};

export const largeHeadingProps: TypographyPresentationProps = {
    forwardAs: "h2",
    transform: "uppercase",
    weight: TYPOGRAPHY.weight.light,
    lineHeight: 1.1,
    css: css`
        ${contentSpacingStyles("0.5em", "0.25em")}
        ${props =>
            breakpointValuesMediaQueries(
                props.theme,
                [
                    { values: [1.15, null, 1.1], properties: ["line-height"] },
                    { values: [30, 32, 36, 40, 45], properties: ["font-size"], unit: "px" },
                ],
                mediaOptions.min,
            )}
    `,
};
